export default __webpack_public_path__ + "static/maxxbw1-0e04e42de168e43151d65e373287cce5.png";